import State from 'interfaces/state/State';

export const isLoading$ = (state: State) => state.account.isLoading;
export const isError$ = (state: State) => state.account.isError;
